import React from "react";

// Laadindicator. role="status" + aria-live="polite": de schermlezer meldt "Laden…" (of
// `label`) zonder de gebruiker te onderbreken.
export default function Spinner({ size = 18, color = "var(--color-primary-600)", label = "Laden…", style }) {
  const s = {
    width: size,
    height: size,
    border: `${Math.max(2, Math.floor(size / 9))}px solid rgba(0,0,0,0.08)`,
    borderTopColor: color,
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    ...style,
  };
  return <span style={s} role="status" aria-live="polite" aria-label={label} />;
}

// global keyframes once
if (typeof document !== "undefined" && !document.getElementById("spinner-keyframes")) {
  const style = document.createElement("style");
  style.id = "spinner-keyframes";
  style.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(style);
}
